module.exports = __webpack_public_path__ + "img/jbt9940_1_1999.prt.16612b3d.jpg";